// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Shared Organization UI — used by org-onboarding + org-admin + org-join */
:root {
  --org-border: #d1d5db;
  --org-border-soft: #e6e6e6;
  --org-surface: #ffffff;
  --org-surface-muted: #f7f8fa;
  --org-muted: #6b7280;
  --org-text: #1a1a1a;
  --org-control-height: 48px;
  --org-control-radius: 8px;
}

.org-page {
  max-width: 960px;
  margin: 24px auto;
  padding: 0 16px 40px;
  color: var(--org-text);
}

.skeleton-org-container {
  padding: 16px 0 8px;
}

.org-page__card {
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  background: var(--org-surface);
  color: inherit;
}

.org-page__card mat-card-header {
  margin-bottom: 8px;
}

.org-page__card mat-card-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--org-text);
}

.org-page__card mat-card-subtitle {
  color: #555;
}

.org-header-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 8px 0 4px;
  align-items: center;
}

/* Bootstrap (3 via CDN + npm) gives every <label> a bottom margin and bold weight. */
.org-field,
.access-role-switch,
.feature-toggle {
  margin: 0;
  max-width: 100%;
  font-weight: inherit;
}

.org-field {
  display: grid;
  gap: 6px;
  width: 100%;
  min-width: 0;
  align-content: end;
}

.org-field__label {
  font-size: 13px;
  font-weight: 600;
  line-height: 1.35;
  color: #374151;
}

.org-input {
  width: 100%;
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  color: var(--org-text);
  background: var(--org-surface);
  border: 1px solid var(--org-border);
  border-radius: var(--org-control-radius);
  padding: 12px 14px;
  margin: 0;
  min-height: var(--org-control-height);
  line-height: 1.4;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  box-sizing: border-box;
}
.org-input::placeholder {
  color: var(--org-muted);
  opacity: 1;
}
.org-input:focus {
  outline: none;
  border-color: var(--org-primary, var(--fc-brand, #5ea1d8));
  box-shadow: 0 0 0 2px rgba(94, 161, 216, 0.15);
}
.org-input:disabled {
  opacity: 0.65;
  cursor: not-allowed;
  background: #f9fafb;
}

textarea.org-input {
  min-height: 96px;
  resize: vertical;
  padding-top: 12px;
  padding-bottom: 12px;
}

input[type=file].org-input {
  height: var(--org-control-height);
  min-height: var(--org-control-height);
  padding: 8px 12px;
  line-height: 30px;
  cursor: pointer;
}
input[type=file].org-input::file-selector-button {
  height: 30px;
  margin: 0 10px 0 0;
  padding: 0 12px;
  border: 1px solid var(--org-border);
  border-radius: 6px;
  background: var(--org-surface-muted);
  color: inherit;
  font: inherit;
  font-size: 13px;
  cursor: pointer;
  vertical-align: middle;
}

select.org-input,
input.org-input:not([type=file]) {
  height: var(--org-control-height);
}

select.org-input {
  -webkit-appearance: none;
          appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%236b7280' d='M1 1l5 5 5-5'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 14px center;
  padding-right: 36px;
}

.org-btn {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin: 0;
  font-family: inherit;
  white-space: nowrap;
  box-sizing: border-box;
  transition: all 0.2s ease;
  text-decoration: none;
  text-transform: none;
  letter-spacing: 0;
  min-height: var(--org-control-height);
  border-radius: var(--org-control-radius);
  font-size: 14px;
  font-weight: 500;
  padding: 12px 20px;
  line-height: 1.2;
}
.org-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}

.org-btn-primary {
  border: none;
  background: var(--org-primary, var(--fc-brand, #5ea1d8));
  color: #fff;
}
.org-btn-primary:hover:not(:disabled) {
  background: #4a8fc4;
}
.org-btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.org-btn-ghost {
  border: 1px solid #d1d5db;
  background: var(--org-surface-muted);
  color: #1f2937;
}
.org-btn-ghost:hover:not(:disabled) {
  background: #e8edf5;
  border-color: #c5cdd8;
}
.org-btn-ghost:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.org-btn-text {
  border: 1px solid var(--org-primary, var(--fc-brand, #5ea1d8));
  background: transparent;
  color: var(--org-primary, var(--fc-brand, #5ea1d8));
}
.org-btn-text:hover:not(:disabled) {
  background: rgba(94, 161, 216, 0.08);
}
.org-btn-text:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.org-btn-dashed {
  width: auto;
  border: 1px dashed var(--org-primary, var(--fc-brand, #5ea1d8));
  background: var(--org-surface-muted);
  color: #1f2937;
}
.org-btn-dashed:hover:not(:disabled) {
  background: #e8edf5;
}
.org-btn-dashed:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.org-btn-dashed--block {
  width: 100%;
}

.org-btn-remove {
  border: none;
  background: transparent;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 600;
  color: #c62828;
  min-height: auto;
  border-radius: 6px;
}
.org-btn-remove:hover:not(:disabled) {
  background: rgba(198, 40, 40, 0.08);
}

.org-btn-warn {
  border: none;
  background: #c62828;
  color: #fff;
}
.org-btn-warn:hover:not(:disabled) {
  background: #b71c1c;
}
.org-btn-warn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.manage-app,
.nested-card {
  border: 1px solid var(--org-border-soft);
  border-radius: 10px;
  padding: 14px;
  background: var(--org-surface-muted);
  display: grid;
  gap: 10px;
  color: var(--org-text);
}

.manage-app__header,
.manage-team__header,
.nested-card__title {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
}

.manage-app__title,
.manage-team__title,
.nested-card__title h3,
.nested-card__title h4 {
  margin: 0;
  font-size: 1rem;
  color: var(--org-text);
}

.manage-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

/* Footer action bar for a form block: secondary first, primary last, right-aligned */
.org-form-actions {
  grid-column: 1/-1;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  justify-content: flex-end;
  margin-top: 4px;
}

.org-form-actions--split {
  justify-content: space-between;
}

.org-form-actions__group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.manage-app__header > .org-btn,
.manage-app__header .manage-actions .org-btn,
.manage-team__header .manage-actions .org-btn,
.nested-card__title > .org-btn {
  height: 36px;
  min-height: 36px;
  padding: 0 14px;
  font-size: 13px;
}

.org-section > .org-btn,
.org-form-panel > .org-btn,
.manage-app > .org-btn:not(.org-btn-dashed--block) {
  justify-self: start;
}

.manage-team,
.team-block {
  margin-left: 4px;
  padding: 10px 12px;
  border-left: 3px solid var(--org-accent, var(--fc-brand, #5ea1d8));
  background: #fff;
  border-radius: 0 8px 8px 0;
  display: grid;
  gap: 8px;
  color: var(--org-text);
}

.edit-grid,
.form-grid,
.terminology-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 10px 12px;
  align-items: end;
}

.edit-grid--inset {
  margin-top: 8px;
}

.edit-grid--grow {
  flex: 1;
  min-width: 0;
}

.invite-row {
  display: flex;
  justify-content: space-between;
  gap: 14px;
  align-items: flex-end;
  padding: 14px 16px;
  border: 1px solid var(--org-border-soft);
  border-radius: 12px;
  background: var(--org-surface);
  color: var(--org-text);
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.invite-row .edit-grid {
  flex: 1;
  min-width: 0;
}

.invite-row > .org-btn {
  flex-shrink: 0;
}

.invite-list {
  display: grid;
  gap: 10px;
}

.invite-card {
  display: grid;
  gap: 12px;
  padding: 16px 18px;
  border: 1px solid var(--org-border-soft);
  border-radius: 14px;
  background: var(--org-surface);
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.05);
  color: var(--org-text);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.invite-card:hover {
  border-color: rgba(94, 161, 216, 0.45);
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.06);
}

.invite-card__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.invite-card__identity {
  display: grid;
  gap: 6px;
  min-width: 0;
}

.invite-card__title {
  margin: 0;
  font-size: 1rem;
  font-weight: 650;
  color: var(--org-text);
  word-break: break-word;
}

.invite-card__subtitle {
  margin: 0;
  font-size: 0.85rem;
  color: var(--org-muted);
  line-height: 1.4;
}

.invite-card__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}

.invite-meta-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 999px;
  background: var(--org-surface-muted);
  border: 1px solid var(--org-border-soft);
  color: #374151;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.2;
}

.invite-card__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
}

.invite-card__body {
  display: grid;
  gap: 10px;
  padding-top: 4px;
  border-top: 1px solid var(--org-border-soft);
}

.invite-card--join .invite-card__body {
  margin-top: 2px;
}

.invite-card__footer {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
  padding-top: 4px;
}

.org-form-panel {
  display: grid;
  gap: 14px;
  padding: 18px;
  border: 1px solid var(--org-border-soft);
  border-radius: 14px;
  background: linear-gradient(180deg, var(--org-surface) 0%, var(--org-surface-muted) 100%);
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
}

.org-form-panel__title {
  margin: 0;
  font-size: 1rem;
  font-weight: 650;
}

.org-form-panel__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  justify-content: flex-end;
}

.org-form-panel__hint {
  margin: -6px 0 0;
  font-size: 0.85rem;
  color: var(--org-muted);
}

.org-section-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px 12px;
  margin-top: 8px;
}

.org-section-head h2 {
  margin: 0;
}

.org-section-head__count {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--org-muted);
}

/* Status badges — Pending / Requested / Accepted / Rejected */
.status-badge,
.pending-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  line-height: 1.2;
  white-space: nowrap;
  border: 1px solid transparent;
  vertical-align: middle;
}

.status-badge mat-icon,
.pending-badge mat-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
}

.status-badge--pending,
.pending-badge {
  background: rgba(242, 169, 0, 0.16);
  color: #8a5a00;
  border-color: rgba(242, 169, 0, 0.28);
  margin-left: 0;
}

.status-badge--requested {
  background: rgba(94, 161, 216, 0.14);
  color: #0b3d5c;
  border-color: rgba(94, 161, 216, 0.3);
}

.status-badge--accepted {
  background: rgba(22, 163, 74, 0.12);
  color: #166534;
  border-color: rgba(22, 163, 74, 0.28);
}

.status-badge--rejected {
  background: rgba(198, 40, 40, 0.1);
  color: #991b1b;
  border-color: rgba(198, 40, 40, 0.22);
}

.status-badge--incoming {
  background: rgba(124, 58, 237, 0.1);
  color: #5b21b6;
  border-color: rgba(124, 58, 237, 0.22);
}

.muted,
.hint {
  color: #555;
  font-size: 0.875rem;
  margin: 0;
}

.muted-empty {
  margin: 0;
  color: #777;
  font-size: 0.85rem;
  padding: 18px 16px;
  text-align: center;
  border: 1px dashed var(--org-border-soft);
  border-radius: 12px;
  background: var(--org-surface-muted);
}

.term-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.term-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px 4px 10px;
  border-radius: 999px;
  background: rgba(94, 161, 216, 0.18);
  color: #1a5278;
  font-size: 0.85rem;
  font-weight: 600;
}

.term-chip__remove {
  border: none;
  background: transparent;
  padding: 0;
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: inherit;
  font-size: 16px;
  line-height: 1;
}

.term-add-row,
.org-inline-row {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 10px;
  align-items: end;
}

.term-add-row .org-btn,
.org-inline-row .org-btn {
  align-self: end;
}

.library-access-panel {
  display: grid;
  gap: 6px;
}

.empty-state {
  text-align: center;
  padding: 40px 16px;
  color: #555;
  display: grid;
  gap: 12px;
  justify-items: center;
}

.empty-state mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  color: var(--fc-brand, #5ea1d8);
}

.org-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 16px 0 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--org-border-soft);
}

.org-tab {
  border: 1px solid transparent;
  background: transparent;
  border-radius: 999px;
  padding: 8px 14px;
  font: inherit;
  font-size: 0.85rem;
  font-weight: 600;
  color: #555;
  cursor: pointer;
  min-height: 36px;
  display: inline-flex;
  align-items: center;
}
.org-tab:hover {
  background: #f5f5f5;
}
.org-tab.active {
  border-color: var(--org-primary, var(--fc-brand, #5ea1d8));
  background: rgba(94, 161, 216, 0.12);
  color: #0b3d5c;
}
.org-tab .status-badge,
.org-tab .pending-badge {
  margin-left: 6px;
}

.org-section {
  display: grid;
  gap: 12px;
}

.org-section h2 {
  margin: 0;
  font-size: 1.1rem;
  color: var(--org-text);
}

.editing-banner {
  margin: 0 0 12px;
  padding: 10px 12px;
  border-radius: 8px;
  background: rgba(94, 161, 216, 0.12);
  color: #1a5278;
  font-size: 0.9rem;
}

/* Access roles — shared by onboarding + admin */
.access-role-list {
  display: grid;
  gap: 12px;
}

.access-role-card {
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  background: #fff;
  overflow: hidden;
}

.access-role-card--off {
  opacity: 0.72;
  background: #fafafa;
}

.access-role-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  border-bottom: 1px solid #eee;
  background: #f8fafc;
}

.access-role-card__toggle-expand {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 0;
  background: transparent;
  font: inherit;
  font-weight: 600;
  cursor: pointer;
  color: var(--org-text);
  padding: 0;
}

.access-role-card__key {
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 0.9rem;
}

.access-role-switch {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 0.85rem;
  font-weight: 600;
  color: #334155;
  -webkit-user-select: none;
          user-select: none;
}

.access-role-switch input,
.feature-toggle input[type=checkbox] {
  width: 16px;
  height: 16px;
  margin: 0;
  flex-shrink: 0;
}

.feature-toggle input[type=checkbox] {
  margin-top: 2px;
}

.access-role-switch.locked {
  opacity: 0.85;
}

.access-role-card__body {
  display: grid;
  gap: 10px;
  padding: 12px;
}

.access-role-features-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.feature-chip {
  display: inline-flex;
  align-items: center;
  padding: 3px 8px;
  border-radius: 999px;
  background: rgba(94, 161, 216, 0.15);
  color: #0b3d5c;
  font-size: 0.75rem;
  font-weight: 600;
}

.access-role-features__title {
  margin: 4px 0 0;
  font-size: 0.9rem;
  font-weight: 600;
}

.feature-toggle {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 8px 0;
  border-top: 1px solid #f0f0f0;
  cursor: pointer;
}

.feature-toggle__text {
  display: grid;
  gap: 2px;
}

.feature-toggle__text strong {
  font-size: 0.9rem;
}

.feature-toggle__text small {
  color: #64748b;
  font-size: 0.8rem;
}

@media (max-width: 640px) {
  .org-page {
    margin-top: 12px;
    padding: 0 12px 32px;
  }
  .invite-row,
  .invite-card,
  .manage-app__header,
  .manage-team__header,
  .nested-card__title {
    flex-direction: column;
    align-items: stretch;
  }
  .invite-card__top,
  .invite-card__footer,
  .invite-card__actions {
    flex-direction: column;
    align-items: stretch;
  }
  .invite-card__actions .org-btn,
  .invite-card__footer .org-btn {
    width: 100%;
  }
  .term-add-row,
  .org-inline-row {
    grid-template-columns: 1fr;
  }
  .term-add-row .org-btn,
  .org-inline-row .org-btn {
    width: 100%;
  }
  .manage-actions .org-btn,
  .org-form-actions .org-btn,
  .org-form-panel__actions .org-btn {
    flex: 1 1 auto;
  }
  .org-form-actions,
  .org-form-actions__group {
    width: 100%;
  }
  .invite-row .org-btn {
    width: 100%;
  }
}
:host-context(body.theme-dark) .org-page {
  color: #e5e7eb;
}
:host-context(body.theme-dark) .org-page__card {
  background: #1e293b;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.35);
  color: #e5e7eb;
}
:host-context(body.theme-dark) .org-page__card mat-card-title,
:host-context(body.theme-dark) .org-section h2,
:host-context(body.theme-dark) .manage-app__title,
:host-context(body.theme-dark) .manage-team__title,
:host-context(body.theme-dark) .nested-card__title h3,
:host-context(body.theme-dark) .nested-card__title h4 {
  color: #f8fafc;
}
:host-context(body.theme-dark) .org-page__card mat-card-subtitle,
:host-context(body.theme-dark) .muted,
:host-context(body.theme-dark) .hint,
:host-context(body.theme-dark) .muted-empty,
:host-context(body.theme-dark) .empty-state {
  color: #94a3b8;
}
:host-context(body.theme-dark) .org-field__label {
  color: #cbd5e1;
}
:host-context(body.theme-dark) .org-input {
  color: #f8fafc;
  background: #0f172a;
  border-color: #475569;
}
:host-context(body.theme-dark) .org-input::placeholder {
  color: #94a3b8;
}
:host-context(body.theme-dark) .org-input:focus {
  border-color: var(--org-primary, var(--fc-brand, #5ea1d8));
  box-shadow: 0 0 0 2px rgba(94, 161, 216, 0.25);
}
:host-context(body.theme-dark) .org-input:disabled {
  background: #1e293b;
}
:host-context(body.theme-dark) .org-btn-ghost {
  border-color: #334155;
  background: #0f172a;
  color: #e5e7eb;
}
:host-context(body.theme-dark) .org-btn-ghost:hover:not(:disabled) {
  background: #334155;
}
:host-context(body.theme-dark) .org-btn-text {
  border-color: var(--org-primary, var(--fc-brand, #5ea1d8));
  color: #7eb8e8;
}
:host-context(body.theme-dark) .org-btn-text:hover:not(:disabled) {
  background: rgba(94, 161, 216, 0.15);
}
:host-context(body.theme-dark) .org-btn-dashed {
  border-color: var(--org-primary, var(--fc-brand, #5ea1d8));
  background: #0f172a;
  color: #e5e7eb;
}
:host-context(body.theme-dark) .org-btn-dashed:hover:not(:disabled) {
  background: #1e293b;
}
:host-context(body.theme-dark) .org-btn-remove {
  color: #f87171;
}
:host-context(body.theme-dark) .org-btn-remove:hover:not(:disabled) {
  background: rgba(248, 113, 113, 0.12);
}
:host-context(body.theme-dark) .manage-app,
:host-context(body.theme-dark) .nested-card,
:host-context(body.theme-dark) .invite-row,
:host-context(body.theme-dark) .invite-card,
:host-context(body.theme-dark) .org-form-panel {
  background: #0f172a;
  border-color: #334155;
  color: #e5e7eb;
}
:host-context(body.theme-dark) .invite-card:hover {
  border-color: rgba(94, 161, 216, 0.5);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);
}
:host-context(body.theme-dark) .invite-card__title {
  color: #f8fafc;
}
:host-context(body.theme-dark) .invite-card__subtitle,
:host-context(body.theme-dark) .org-form-panel__hint,
:host-context(body.theme-dark) .org-section-head__count {
  color: #94a3b8;
}
:host-context(body.theme-dark) .invite-card__body {
  border-top-color: #334155;
}
:host-context(body.theme-dark) .invite-meta-chip {
  background: #1e293b;
  border-color: #334155;
  color: #cbd5e1;
}
:host-context(body.theme-dark) .muted-empty {
  background: #0f172a;
  border-color: #334155;
  color: #94a3b8;
}
:host-context(body.theme-dark) .manage-team,
:host-context(body.theme-dark) .team-block {
  background: #1e293b;
  color: #e5e7eb;
}
:host-context(body.theme-dark) .org-tabs {
  border-bottom-color: #334155;
}
:host-context(body.theme-dark) .org-tab {
  color: #94a3b8;
}
:host-context(body.theme-dark) .org-tab:hover {
  background: #0f172a;
}
:host-context(body.theme-dark) .org-tab.active {
  border-color: var(--org-primary, var(--fc-brand, #5ea1d8));
  background: rgba(94, 161, 216, 0.2);
  color: #e0f2fe;
}
:host-context(body.theme-dark) .pending-badge,
:host-context(body.theme-dark) .status-badge--pending {
  background: rgba(242, 169, 0, 0.25);
  color: #fbbf24;
  border-color: rgba(242, 169, 0, 0.35);
}
:host-context(body.theme-dark) .status-badge--requested {
  background: rgba(94, 161, 216, 0.22);
  color: #7dd3fc;
  border-color: rgba(94, 161, 216, 0.35);
}
:host-context(body.theme-dark) .status-badge--accepted {
  background: rgba(34, 197, 94, 0.18);
  color: #86efac;
  border-color: rgba(34, 197, 94, 0.3);
}
:host-context(body.theme-dark) .status-badge--rejected {
  background: rgba(248, 113, 113, 0.15);
  color: #fca5a5;
  border-color: rgba(248, 113, 113, 0.28);
}
:host-context(body.theme-dark) .status-badge--incoming {
  background: rgba(167, 139, 250, 0.18);
  color: #c4b5fd;
  border-color: rgba(167, 139, 250, 0.3);
}
:host-context(body.theme-dark) .term-chip {
  background: rgba(94, 161, 216, 0.25);
  color: #bae6fd;
}
:host-context(body.theme-dark) .editing-banner {
  background: rgba(94, 161, 216, 0.2);
  color: #bae6fd;
}
:host-context(body.theme-dark) .empty-state mat-icon {
  color: var(--fc-brand, #5ea1d8);
}
:host-context(body.theme-dark) .access-role-card {
  background: #0f172a;
  border-color: #334155;
}
:host-context(body.theme-dark) .access-role-card--off {
  background: #0b1220;
}
:host-context(body.theme-dark) .access-role-card__header {
  background: #111827;
  border-color: #334155;
}
:host-context(body.theme-dark) .access-role-card__toggle-expand,
:host-context(body.theme-dark) .access-role-switch,
:host-context(body.theme-dark) .access-role-features__title {
  color: #e2e8f0;
}
:host-context(body.theme-dark) .feature-chip {
  background: rgba(94, 161, 216, 0.22);
  color: #bae6fd;
}
:host-context(body.theme-dark) .feature-toggle {
  border-color: #1e293b;
}
:host-context(body.theme-dark) .feature-toggle__text small {
  color: #94a3b8;
}

.org-page {
  max-width: 860px;
}

.org-blocked {
  padding: 24px 8px 8px;
  text-align: center;
}

.org-blocked h3 {
  margin: 0 0 8px;
  font-size: 1.25rem;
}

.org-blocked p {
  margin: 0 0 20px;
  color: #555;
  line-height: 1.45;
}

/* Progress above the step strip */
.org-progress {
  margin: 16px 0 12px;
  display: grid;
  gap: 6px;
}

.org-progress__meta {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  font-size: 0.8rem;
}

.org-progress__label {
  color: #6b7280;
  font-weight: 600;
}

.org-progress__value {
  color: #16a34a;
  font-weight: 700;
}

.org-progress__bar {
  height: 6px;
  border-radius: 999px;
  background: #e5e7eb;
  overflow: hidden;
}

.org-progress__fill {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #16a34a;
  transition: width 0.3s ease;
}

/* Prev/next arrows on either side of the step strip */
.org-steps-nav {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0 0 24px;
}

.org-steps-arrow {
  flex: 0 0 auto;
  width: 32px;
  height: 32px;
  padding: 0;
  border-radius: 50%;
  border: 1px solid #e5e7eb;
  background: #fff;
  color: #374151;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}
.org-steps-arrow mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
  line-height: 22px;
}
.org-steps-arrow:hover:not(:disabled) {
  border-color: var(--org-primary, var(--fc-brand, #5ea1d8));
  color: var(--org-primary, var(--fc-brand, #5ea1d8));
}
.org-steps-arrow:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* Step strip: one line, styled like the Create Guide journey tabs */
.org-steps {
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
  flex-wrap: nowrap;
  align-items: center;
  gap: 0;
  margin: 0;
  padding: 4px 2px;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  touch-action: pan-x;
}
.org-steps::-webkit-scrollbar {
  display: none;
}

.org-step {
  background: transparent;
  border: none;
  padding: 0;
  font: inherit;
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  cursor: pointer;
  color: #9ca3af;
  white-space: nowrap;
  transition: color 0.2s ease;
  touch-action: pan-x;
}
.org-step:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  pointer-events: auto;
}

.org-step__label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  line-height: 1.2;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 7px 14px;
  border-radius: 35px;
  border: 2px solid currentColor;
  background: transparent;
}

.org-step__num {
  font-weight: 700;
}

.org-step__check {
  font-size: 16px;
  width: 16px;
  height: 16px;
  line-height: 16px;
}

.org-step.active {
  color: var(--org-primary, var(--fc-brand, #5ea1d8));
}
.org-step.active .org-step__label {
  background: rgba(94, 161, 216, 0.1);
}

.org-step.done {
  color: #16a34a;
}
.org-step.done .org-step__label {
  background: rgba(22, 163, 74, 0.1);
}

.org-step-connector {
  flex: 1 0 20px;
  min-width: 20px;
  height: 2px;
  margin: 0 6px;
  background: #e5e7eb;
}

.org-step-connector--done {
  background: #16a34a;
}

/* Alternate admin opt-in */
.alt-admin-toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  color: #334155;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.alt-admin-toggle input {
  width: 16px;
  height: 16px;
  margin: 0;
}

.org-panel {
  display: grid;
  gap: 12px;
}

.org-panel .term-value-group + .term-value-group {
  margin-top: 4px;
}

.nested-card {
  margin-bottom: 4px;
}

.term-section-title {
  margin: 8px 0 4px;
  font-size: 1.05rem;
  font-weight: 600;
  color: #1a1a1a;
}

.term-value-group {
  padding: 14px;
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  background: #f7f8fa;
  display: grid;
  gap: 10px;
}

.term-value-group__header h4 {
  margin: 0 0 4px;
  font-size: 1rem;
  color: #1a1a1a;
}

.color-row {
  display: flex;
  gap: 12px;
  align-items: end;
}

.color-row .org-field {
  flex: 1;
}

.color-swatch {
  width: 48px;
  height: 48px;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 0;
  background: none;
  cursor: pointer;
  flex-shrink: 0;
}

.logo-upload-row {
  display: grid;
  gap: 12px;
}

.logo-preview {
  display: flex;
  align-items: center;
  gap: 12px;
}

.logo-preview img {
  max-height: 64px;
  max-width: 180px;
  object-fit: contain;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #fff;
  padding: 6px;
}

.logo-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
}

.done-panel {
  text-align: center;
  padding: 24px 8px;
  color: #1a1a1a;
  display: grid;
  gap: 12px;
  justify-items: center;
}

.done-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  color: #2e7d32;
}

.done-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
  margin-top: 8px;
  align-items: center;
}

.invited-list {
  width: 100%;
  max-width: 480px;
  text-align: left;
  display: grid;
  gap: 8px;
  margin: 8px 0 0;
}

.invited-list ul {
  margin: 0;
  padding: 0;
  display: grid;
  gap: 8px;
}

.invited-list__heading {
  font-weight: 650;
  color: #374151;
}

.invited-list li {
  list-style: none;
  padding: 12px 14px;
  border-radius: 12px;
  background: #fff;
  border: 1px solid #e6e6e6;
  font-size: 0.9rem;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.invited-list__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
}

.invited-list__email {
  font-weight: 600;
  color: #1a1a1a;
  word-break: break-word;
}

.invited-list__note {
  margin: 6px 0 0;
  font-size: 0.8rem;
  color: #6b7280;
}

.org-actions {
  padding: 8px 16px 16px;
  gap: 8px;
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  align-items: center;
}

@media (max-width: 640px) {
  .org-steps-nav {
    gap: 4px;
  }
  .org-steps-arrow {
    width: 28px;
    height: 28px;
  }
  .org-step-connector {
    flex: 0 0 16px;
    min-width: 16px;
    margin: 0 4px;
  }
  .org-step__label {
    font-size: 11px;
    letter-spacing: 0.02em;
    padding: 6px 12px;
  }
  .color-row {
    flex-direction: column;
    align-items: stretch;
  }
  .done-actions .org-btn,
  .org-actions .org-btn {
    flex: 1 1 auto;
  }
}
:host-context(body.theme-dark) .org-steps-arrow {
  background: #0f172a;
  border-color: #334155;
  color: #e2e8f0;
}
:host-context(body.theme-dark) .org-step {
  color: #64748b;
}
:host-context(body.theme-dark) .org-step.active {
  color: var(--org-primary, var(--fc-brand, #5ea1d8));
}
:host-context(body.theme-dark) .org-step.active .org-step__label {
  background: rgba(94, 161, 216, 0.15);
}
:host-context(body.theme-dark) .org-step.done {
  color: #4ade80;
}
:host-context(body.theme-dark) .org-step.done .org-step__label {
  background: rgba(74, 222, 128, 0.12);
}
:host-context(body.theme-dark) .org-step-connector {
  background: rgba(148, 163, 184, 0.2);
}
:host-context(body.theme-dark) .org-step-connector--done,
:host-context(body.theme-dark) .org-progress__fill {
  background: #4ade80;
}
:host-context(body.theme-dark) .org-progress__bar {
  background: rgba(148, 163, 184, 0.2);
}
:host-context(body.theme-dark) .org-progress__label {
  color: #94a3b8;
}
:host-context(body.theme-dark) .org-progress__value {
  color: #4ade80;
}
:host-context(body.theme-dark) .alt-admin-toggle {
  color: #e2e8f0;
}
:host-context(body.theme-dark) .term-section-title,
:host-context(body.theme-dark) .term-value-group__header h4,
:host-context(body.theme-dark) .done-panel {
  color: #f8fafc;
}
:host-context(body.theme-dark) .term-value-group,
:host-context(body.theme-dark) .invited-list li {
  background: #0f172a;
  border-color: #334155;
}
:host-context(body.theme-dark) .invited-list__heading,
:host-context(body.theme-dark) .invited-list__email {
  color: #e2e8f0;
}
:host-context(body.theme-dark) .invited-list__note {
  color: #94a3b8;
}
:host-context(body.theme-dark) .logo-preview img {
  border-color: #475569;
  background: #0f172a;
}
:host-context(body.theme-dark) .color-swatch {
  border-color: #475569;
}
:host-context(body.theme-dark) .done-icon {
  color: #4ade80;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/org-onboarding/org-onboarding.component.scss","webpack://./src/app/shared/styles/org-ui.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB,2EAAA;AAEA;EACE,qBAAA;EACA,0BAAA;EACA,sBAAA;EACA,4BAAA;EACA,oBAAA;EACA,mBAAA;EACA,0BAAA;EACA,yBAAA;ADCF;;ACEA;EACE,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;ADCF;;ACEA;EACE,mBAAA;ADCF;;ACEA;EACE,mBAAA;EACA,0CAAA;EACA,8BAAA;EACA,cAAA;ADCF;;ACEA;EACE,kBAAA;ADCF;;ACEA;EACE,iBAAA;EACA,gBAAA;EACA,sBAAA;ADCF;;ACEA;EACE,WAAA;ADCF;;ACEA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;ADCF;;ACEA,qFAAA;AACA;;;EAGE,SAAA;EACA,eAAA;EACA,oBAAA;ADCF;;ACEA;EACE,aAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;ADCF;;ACEA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;ADCF;;ACEA;EACE,WAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,8BAAA;EACA,mCAAA;EACA,wCAAA;EACA,kBAAA;EACA,SAAA;EACA,qCAAA;EACA,gBAAA;EACA,0DAAA;EACA,sBAAA;ADCF;ACCE;EACE,uBAAA;EACA,UAAA;ADCJ;ACEE;EACE,aAAA;EACA,0DAAA;EACA,8CAAA;ADAJ;ACGE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;ADDJ;;ACKA;EACE,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;ADFF;;ACKA;EACE,iCAAA;EACA,qCAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;ADFF;ACIE;EACE,YAAA;EACA,kBAAA;EACA,eAAA;EACA,mCAAA;EACA,kBAAA;EACA,oCAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,sBAAA;ADFJ;;ACMA;;EAEE,iCAAA;ADHF;;ACMA;EACE,wBAAA;UAAA,gBAAA;EACA,wLAAA;EACA,4BAAA;EACA,sCAAA;EACA,mBAAA;ADHF;;ACMA;EACE,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,qBAAA;EACA,oBAAA;EACA,iBAAA;EACA,qCAAA;EACA,wCAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;ADHF;ACKE;EACE,eAAA;EACA,WAAA;EACA,YAAA;ADHJ;;ACOA;EACE,YAAA;EACA,wDAAA;EACA,WAAA;ADJF;ACME;EACE,mBAAA;ADJJ;ACOE;EACE,YAAA;EACA,mBAAA;ADLJ;;ACSA;EACE,yBAAA;EACA,oCAAA;EACA,cAAA;ADNF;ACQE;EACE,mBAAA;EACA,qBAAA;ADNJ;ACSE;EACE,aAAA;EACA,mBAAA;ADPJ;;ACWA;EACE,8DAAA;EACA,uBAAA;EACA,mDAAA;ADRF;ACUE;EACE,oCAAA;ADRJ;ACWE;EACE,aAAA;EACA,mBAAA;ADTJ;;ACaA;EACE,WAAA;EACA,+DAAA;EACA,oCAAA;EACA,cAAA;ADVF;ACYE;EACE,mBAAA;ADVJ;ACaE;EACE,aAAA;EACA,mBAAA;ADXJ;;ACeA;EACE,WAAA;ADZF;;ACeA;EACE,YAAA;EACA,uBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;ADZF;ACcE;EACE,mCAAA;ADZJ;;ACgBA;EACE,YAAA;EACA,mBAAA;EACA,WAAA;ADbF;ACeE;EACE,mBAAA;ADbJ;ACgBE;EACE,YAAA;EACA,mBAAA;ADdJ;;ACkBA;;EAEE,wCAAA;EACA,mBAAA;EACA,aAAA;EACA,oCAAA;EACA,aAAA;EACA,SAAA;EACA,sBAAA;ADfF;;ACkBA;;;EAGE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;EACA,8BAAA;ADfF;;ACkBA;;;;EAIE,SAAA;EACA,eAAA;EACA,sBAAA;ADfF;;ACkBA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;ADfF;;ACkBA,qFAAA;AACA;EACE,iBAAA;EACA,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;ADfF;;ACkBA;EACE,8BAAA;ADfF;;ACkBA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;ADfF;;ACkBA;;;;EAIE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;ADfF;;ACkBA;;;EAGE,mBAAA;ADfF;;ACkBA;;EAEE,gBAAA;EACA,kBAAA;EACA,kEAAA;EACA,gBAAA;EACA,0BAAA;EACA,aAAA;EACA,QAAA;EACA,sBAAA;ADfF;;ACkBA;;;EAGE,aAAA;EACA,2DAAA;EACA,cAAA;EACA,gBAAA;ADfF;;ACkBA;EACE,eAAA;ADfF;;ACkBA;EACE,OAAA;EACA,YAAA;ADfF;;ACkBA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,qBAAA;EACA,kBAAA;EACA,wCAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,4CAAA;ADfF;;ACkBA;EACE,OAAA;EACA,YAAA;ADfF;;ACkBA;EACE,cAAA;ADfF;;ACkBA;EACE,aAAA;EACA,SAAA;ADfF;;ACkBA;EACE,aAAA;EACA,SAAA;EACA,kBAAA;EACA,wCAAA;EACA,mBAAA;EACA,8BAAA;EACA,4CAAA;EACA,sBAAA;EACA,0DAAA;ADfF;;ACkBA;EACE,sCAAA;EACA,6CAAA;ADfF;;ACkBA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;ADfF;;ACkBA;EACE,aAAA;EACA,QAAA;EACA,YAAA;ADfF;;ACkBA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;ADfF;;ACkBA;EACE,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;ADfF;;ACkBA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;ADfF;;ACkBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,oBAAA;EACA,oCAAA;EACA,wCAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;ADfF;;ACkBA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;ADfF;;ACkBA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,4CAAA;ADfF;;ACkBA;EACE,eAAA;ADfF;;ACkBA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,yBAAA;EACA,gBAAA;ADfF;;ACkBA;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,wCAAA;EACA,mBAAA;EACA,yFAAA;EAKA,4CAAA;ADnBF;;ACsBA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;ADnBF;;ACsBA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;EACA,yBAAA;ADnBF;;ACsBA;EACE,gBAAA;EACA,kBAAA;EACA,uBAAA;ADnBF;;ACsBA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,eAAA;ADnBF;;ACsBA;EACE,SAAA;ADnBF;;ACsBA;EACE,iBAAA;EACA,gBAAA;EACA,uBAAA;ADnBF;;ACsBA,8DAAA;AACA;;EAEE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;EACA,sBAAA;ADnBF;;ACsBA;;EAEE,eAAA;EACA,WAAA;EACA,YAAA;ADnBF;;ACsBA;;EAEE,mCAAA;EACA,cAAA;EACA,qCAAA;EACA,cAAA;ADnBF;;ACsBA;EACE,oCAAA;EACA,cAAA;EACA,qCAAA;ADnBF;;ACsBA;EACE,mCAAA;EACA,cAAA;EACA,qCAAA;ADnBF;;ACsBA;EACE,kCAAA;EACA,cAAA;EACA,qCAAA;ADnBF;;ACsBA;EACE,mCAAA;EACA,cAAA;EACA,sCAAA;ADnBF;;ACsBA;;EAEE,WAAA;EACA,mBAAA;EACA,SAAA;ADnBF;;ACsBA;EACE,SAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yCAAA;EACA,mBAAA;EACA,oCAAA;ADnBF;;ACsBA;EACE,aAAA;EACA,eAAA;EACA,QAAA;ADnBF;;ACsBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,oBAAA;EACA,oCAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;ADnBF;;ACsBA;EACE,YAAA;EACA,uBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;ADnBF;;ACsBA;;EAEE,aAAA;EACA,+BAAA;EACA,SAAA;EACA,gBAAA;ADnBF;;ACsBA;;EAEE,eAAA;ADnBF;;ACsBA;EACE,aAAA;EACA,QAAA;ADnBF;;ACsBA;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,SAAA;EACA,qBAAA;ADnBF;;ACsBA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;ADnBF;;ACsBA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;EACA,oBAAA;EACA,+CAAA;ADnBF;;ACsBA;EACE,6BAAA;EACA,uBAAA;EACA,oBAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;ADnBF;ACqBE;EACE,mBAAA;ADnBJ;ACsBE;EACE,0DAAA;EACA,oCAAA;EACA,cAAA;ADpBJ;ACuBE;;EAEE,gBAAA;ADrBJ;;ACyBA;EACE,aAAA;EACA,SAAA;ADtBF;;ACyBA;EACE,SAAA;EACA,iBAAA;EACA,sBAAA;ADtBF;;ACyBA;EACE,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oCAAA;EACA,cAAA;EACA,iBAAA;ADtBF;;ACyBA,gDAAA;AACA;EACE,aAAA;EACA,SAAA;ADtBF;;ACyBA;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;ADtBF;;ACyBA;EACE,aAAA;EACA,mBAAA;ADtBF;;ACyBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBAAA;ADtBF;;ACyBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EACA,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,UAAA;ADtBF;;ACyBA;EACE,qEAAA;EACA,iBAAA;ADtBF;;ACyBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;UAAA,iBAAA;ADtBF;;ACyBA;;EAEE,WAAA;EACA,YAAA;EACA,SAAA;EACA,cAAA;ADtBF;;ACyBA;EACE,eAAA;ADtBF;;ACyBA;EACE,aAAA;ADtBF;;ACyBA;EACE,aAAA;EACA,SAAA;EACA,aAAA;ADtBF;;ACyBA;EACE,aAAA;EACA,eAAA;EACA,QAAA;ADtBF;;ACyBA;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,oCAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;ADtBF;;ACyBA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;ADtBF;;ACyBA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,cAAA;EACA,6BAAA;EACA,eAAA;ADtBF;;ACyBA;EACE,aAAA;EACA,QAAA;ADtBF;;ACyBA;EACE,iBAAA;ADtBF;;ACyBA;EACE,cAAA;EACA,iBAAA;ADtBF;;ACyBA;EACE;IACE,gBAAA;IACA,oBAAA;EDtBF;ECyBA;;;;;IAKE,sBAAA;IACA,oBAAA;EDvBF;EC0BA;;;IAGE,sBAAA;IACA,oBAAA;EDxBF;EC2BA;;IAEE,WAAA;EDzBF;EC4BA;;IAEE,0BAAA;ED1BF;EC6BA;;IAEE,WAAA;ED3BF;EC8BA;;;IAGE,cAAA;ED5BF;EC+BA;;IAEE,WAAA;ED7BF;ECgCA;IACE,WAAA;ED9BF;AACF;ACkCE;EACE,cAAA;ADhCJ;ACmCE;EACE,mBAAA;EACA,0CAAA;EACA,cAAA;ADjCJ;ACoCE;;;;;;EAME,cAAA;ADlCJ;ACqCE;;;;;EAKE,cAAA;ADnCJ;ACsCE;EACE,cAAA;ADpCJ;ACuCE;EACE,cAAA;EACA,mBAAA;EACA,qBAAA;ADrCJ;ACuCI;EACE,cAAA;ADrCN;ACwCI;EACE,0DAAA;EACA,8CAAA;ADtCN;ACyCI;EACE,mBAAA;ADvCN;AC2CE;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;ADzCJ;AC2CI;EACE,mBAAA;ADzCN;AC6CE;EACE,0DAAA;EACA,cAAA;AD3CJ;AC6CI;EACE,oCAAA;AD3CN;AC+CE;EACE,0DAAA;EACA,mBAAA;EACA,cAAA;AD7CJ;AC+CI;EACE,mBAAA;AD7CN;ACiDE;EACE,cAAA;AD/CJ;ACiDI;EACE,qCAAA;AD/CN;ACmDE;;;;;EAKE,mBAAA;EACA,qBAAA;EACA,cAAA;ADjDJ;ACoDE;EACE,qCAAA;EACA,0CAAA;ADlDJ;ACqDE;EACE,cAAA;ADnDJ;ACsDE;;;EAGE,cAAA;ADpDJ;ACuDE;EACE,yBAAA;ADrDJ;ACwDE;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;ADtDJ;ACyDE;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;ADvDJ;AC0DE;;EAEE,mBAAA;EACA,cAAA;ADxDJ;AC2DE;EACE,4BAAA;ADzDJ;AC4DE;EACE,cAAA;AD1DJ;AC4DI;EACE,mBAAA;AD1DN;AC6DI;EACE,0DAAA;EACA,mCAAA;EACA,cAAA;AD3DN;AC+DE;;EAEE,mCAAA;EACA,cAAA;EACA,qCAAA;AD7DJ;ACgEE;EACE,oCAAA;EACA,cAAA;EACA,sCAAA;AD9DJ;ACiEE;EACE,mCAAA;EACA,cAAA;EACA,oCAAA;AD/DJ;ACkEE;EACE,qCAAA;EACA,cAAA;EACA,uCAAA;ADhEJ;ACmEE;EACE,qCAAA;EACA,cAAA;EACA,sCAAA;ADjEJ;ACoEE;EACE,oCAAA;EACA,cAAA;ADlEJ;ACqEE;EACE,mCAAA;EACA,cAAA;ADnEJ;ACsEE;EACE,+BAAA;ADpEJ;ACuEE;EACE,mBAAA;EACA,qBAAA;ADrEJ;ACwEE;EACE,mBAAA;ADtEJ;ACyEE;EACE,mBAAA;EACA,qBAAA;ADvEJ;AC0EE;;;EAGE,cAAA;ADxEJ;AC2EE;EACE,oCAAA;EACA,cAAA;ADzEJ;AC4EE;EACE,qBAAA;AD1EJ;AC6EE;EACE,cAAA;AD3EJ;;AA7jCA;EACE,gBAAA;AAgkCF;;AA7jCA;EACE,qBAAA;EACA,kBAAA;AAgkCF;;AA7jCA;EACE,eAAA;EACA,kBAAA;AAgkCF;;AA7jCA;EACE,gBAAA;EACA,WAAA;EACA,iBAAA;AAgkCF;;AA7jCA,kCAAA;AACA;EACE,mBAAA;EACA,aAAA;EACA,QAAA;AAgkCF;;AA7jCA;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,iBAAA;AAgkCF;;AA7jCA;EACE,cAAA;EACA,gBAAA;AAgkCF;;AA7jCA;EACE,cAAA;EACA,gBAAA;AAgkCF;;AA7jCA;EACE,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;AAgkCF;;AA7jCA;EACE,cAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;AAgkCF;;AA7jCA,sDAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AAgkCF;;AA7jCA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,0DAAA;AAgkCF;AA9jCE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAgkCJ;AA7jCE;EACE,0DAAA;EACA,mDAAA;AA+jCJ;AA5jCE;EACE,aAAA;EACA,mBAAA;AA8jCJ;;AA1jCA,oEAAA;AACA;EACE,aAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,MAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;EACA,qBAAA;EACA,mBAAA;AA6jCF;AA3jCE;EACE,aAAA;AA6jCJ;;AAzjCA;EACE,uBAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;AA4jCF;AA1jCE;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;AA4jCJ;;AAxjCA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;AA2jCF;;AAxjCA;EACE,gBAAA;AA2jCF;;AAxjCA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AA2jCF;;AAxjCA;EACE,mDAAA;AA2jCF;AAzjCE;EACE,mCAAA;AA2jCJ;;AAvjCA;EACE,cAAA;AA0jCF;AAxjCE;EACE,kCAAA;AA0jCJ;;AAtjCA;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;AAyjCF;;AAtjCA;EACE,mBAAA;AAyjCF;;AAtjCA,2BAAA;AACA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AAyjCF;AAvjCE;EACE,WAAA;EACA,YAAA;EACA,SAAA;AAyjCJ;;AArjCA;EACE,aAAA;EACA,SAAA;AAwjCF;;AArjCA;EACE,eAAA;AAwjCF;;AArjCA;EACE,kBAAA;AAwjCF;;AArjCA;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAwjCF;;AArjCA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;AAwjCF;;AArjCA;EACE,eAAA;EACA,eAAA;EACA,cAAA;AAwjCF;;AArjCA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AAwjCF;;AArjCA;EACE,OAAA;AAwjCF;;AArjCA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAwjCF;;AArjCA;EACE,aAAA;EACA,SAAA;AAwjCF;;AArjCA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAwjCF;;AArjCA;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AAwjCF;;AArjCA;EACE,aAAA;EACA,QAAA;EACA,eAAA;EACA,mBAAA;AAwjCF;;AArjCA;EACE,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;EACA,qBAAA;AAwjCF;;AArjCA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAwjCF;;AArjCA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;AAwjCF;;AArjCA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,QAAA;EACA,eAAA;AAwjCF;;AArjCA;EACE,SAAA;EACA,UAAA;EACA,aAAA;EACA,QAAA;AAwjCF;;AArjCA;EACE,gBAAA;EACA,cAAA;AAwjCF;;AArjCA;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;EACA,4CAAA;AAwjCF;;AArjCA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;AAwjCF;;AArjCA;EACE,gBAAA;EACA,cAAA;EACA,sBAAA;AAwjCF;;AArjCA;EACE,eAAA;EACA,iBAAA;EACA,cAAA;AAwjCF;;AArjCA;EACE,sBAAA;EACA,QAAA;EACA,aAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;AAwjCF;;AArjCA;EACE;IACE,QAAA;EAwjCF;EArjCA;IACE,WAAA;IACA,YAAA;EAujCF;EApjCA;IACE,cAAA;IACA,eAAA;IACA,aAAA;EAsjCF;EAnjCA;IACE,eAAA;IACA,sBAAA;IACA,iBAAA;EAqjCF;EAljCA;IACE,sBAAA;IACA,oBAAA;EAojCF;EAjjCA;;IAEE,cAAA;EAmjCF;AACF;AA/iCE;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAijCJ;AA9iCE;EACE,cAAA;AAgjCJ;AA7iCE;EACE,mDAAA;AA+iCJ;AA7iCI;EACE,oCAAA;AA+iCN;AA3iCE;EACE,cAAA;AA6iCJ;AA3iCI;EACE,oCAAA;AA6iCN;AAziCE;EACE,oCAAA;AA2iCJ;AAxiCE;;EAEE,mBAAA;AA0iCJ;AAviCE;EACE,oCAAA;AAyiCJ;AAtiCE;EACE,cAAA;AAwiCJ;AAriCE;EACE,cAAA;AAuiCJ;AApiCE;EACE,cAAA;AAsiCJ;AAniCE;;;EAGE,cAAA;AAqiCJ;AAliCE;;EAEE,mBAAA;EACA,qBAAA;AAoiCJ;AAjiCE;;EAEE,cAAA;AAmiCJ;AAhiCE;EACE,cAAA;AAkiCJ;AA/hCE;EACE,qBAAA;EACA,mBAAA;AAiiCJ;AA9hCE;EACE,qBAAA;AAgiCJ;AA7hCE;EACE,cAAA;AA+hCJ","sourcesContent":["@import \"../../shared/styles/org-ui\";\n\n.org-page {\n  max-width: 860px;\n}\n\n.org-blocked {\n  padding: 24px 8px 8px;\n  text-align: center;\n}\n\n.org-blocked h3 {\n  margin: 0 0 8px;\n  font-size: 1.25rem;\n}\n\n.org-blocked p {\n  margin: 0 0 20px;\n  color: #555;\n  line-height: 1.45;\n}\n\n/* Progress above the step strip */\n.org-progress {\n  margin: 16px 0 12px;\n  display: grid;\n  gap: 6px;\n}\n\n.org-progress__meta {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  font-size: 0.8rem;\n}\n\n.org-progress__label {\n  color: #6b7280;\n  font-weight: 600;\n}\n\n.org-progress__value {\n  color: #16a34a;\n  font-weight: 700;\n}\n\n.org-progress__bar {\n  height: 6px;\n  border-radius: 999px;\n  background: #e5e7eb;\n  overflow: hidden;\n}\n\n.org-progress__fill {\n  display: block;\n  height: 100%;\n  border-radius: inherit;\n  background: #16a34a;\n  transition: width 0.3s ease;\n}\n\n/* Prev/next arrows on either side of the step strip */\n.org-steps-nav {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin: 0 0 24px;\n}\n\n.org-steps-arrow {\n  flex: 0 0 auto;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border-radius: 50%;\n  border: 1px solid #e5e7eb;\n  background: #fff;\n  color: #374151;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n\n  mat-icon {\n    font-size: 22px;\n    width: 22px;\n    height: 22px;\n    line-height: 22px;\n  }\n\n  &:hover:not(:disabled) {\n    border-color: var(--org-primary, var(--fc-brand, #5ea1d8));\n    color: var(--org-primary, var(--fc-brand, #5ea1d8));\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n  }\n}\n\n/* Step strip: one line, styled like the Create Guide journey tabs */\n.org-steps {\n  display: flex;\n  flex: 1 1 auto;\n  min-width: 0;\n  flex-wrap: nowrap;\n  align-items: center;\n  gap: 0;\n  margin: 0;\n  padding: 4px 2px;\n  overflow-x: auto;\n  overflow-y: hidden;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n  touch-action: pan-x;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n.org-step {\n  background: transparent;\n  border: none;\n  padding: 0;\n  font: inherit;\n  display: flex;\n  align-items: center;\n  flex: 0 0 auto;\n  cursor: pointer;\n  color: #9ca3af;\n  white-space: nowrap;\n  transition: color 0.2s ease;\n  touch-action: pan-x;\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n    pointer-events: auto;\n  }\n}\n\n.org-step__label {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  line-height: 1.2;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  padding: 7px 14px;\n  border-radius: 35px;\n  border: 2px solid currentColor;\n  background: transparent;\n}\n\n.org-step__num {\n  font-weight: 700;\n}\n\n.org-step__check {\n  font-size: 16px;\n  width: 16px;\n  height: 16px;\n  line-height: 16px;\n}\n\n.org-step.active {\n  color: var(--org-primary, var(--fc-brand, #5ea1d8));\n\n  .org-step__label {\n    background: rgba(94, 161, 216, 0.1);\n  }\n}\n\n.org-step.done {\n  color: #16a34a;\n\n  .org-step__label {\n    background: rgba(22, 163, 74, 0.1);\n  }\n}\n\n.org-step-connector {\n  flex: 1 0 20px;\n  min-width: 20px;\n  height: 2px;\n  margin: 0 6px;\n  background: #e5e7eb;\n}\n\n.org-step-connector--done {\n  background: #16a34a;\n}\n\n/* Alternate admin opt-in */\n.alt-admin-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #334155;\n  cursor: pointer;\n  user-select: none;\n\n  input {\n    width: 16px;\n    height: 16px;\n    margin: 0;\n  }\n}\n\n.org-panel {\n  display: grid;\n  gap: 12px;\n}\n\n.org-panel .term-value-group + .term-value-group {\n  margin-top: 4px;\n}\n\n.nested-card {\n  margin-bottom: 4px;\n}\n\n.term-section-title {\n  margin: 8px 0 4px;\n  font-size: 1.05rem;\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n.term-value-group {\n  padding: 14px;\n  border: 1px solid #e6e6e6;\n  border-radius: 10px;\n  background: #f7f8fa;\n  display: grid;\n  gap: 10px;\n}\n\n.term-value-group__header h4 {\n  margin: 0 0 4px;\n  font-size: 1rem;\n  color: #1a1a1a;\n}\n\n.color-row {\n  display: flex;\n  gap: 12px;\n  align-items: end;\n}\n\n.color-row .org-field {\n  flex: 1;\n}\n\n.color-swatch {\n  width: 48px;\n  height: 48px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  padding: 0;\n  background: none;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.logo-upload-row {\n  display: grid;\n  gap: 12px;\n}\n\n.logo-preview {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.logo-preview img {\n  max-height: 64px;\n  max-width: 180px;\n  object-fit: contain;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  background: #fff;\n  padding: 6px;\n}\n\n.logo-actions {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.done-panel {\n  text-align: center;\n  padding: 24px 8px;\n  color: #1a1a1a;\n  display: grid;\n  gap: 12px;\n  justify-items: center;\n}\n\n.done-icon {\n  font-size: 48px;\n  width: 48px;\n  height: 48px;\n  color: #2e7d32;\n}\n\n.done-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  justify-content: center;\n  margin-top: 8px;\n  align-items: center;\n}\n\n.invited-list {\n  width: 100%;\n  max-width: 480px;\n  text-align: left;\n  display: grid;\n  gap: 8px;\n  margin: 8px 0 0;\n}\n\n.invited-list ul {\n  margin: 0;\n  padding: 0;\n  display: grid;\n  gap: 8px;\n}\n\n.invited-list__heading {\n  font-weight: 650;\n  color: #374151;\n}\n\n.invited-list li {\n  list-style: none;\n  padding: 12px 14px;\n  border-radius: 12px;\n  background: #fff;\n  border: 1px solid #e6e6e6;\n  font-size: 0.9rem;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.invited-list__row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.invited-list__email {\n  font-weight: 600;\n  color: #1a1a1a;\n  word-break: break-word;\n}\n\n.invited-list__note {\n  margin: 6px 0 0;\n  font-size: 0.8rem;\n  color: #6b7280;\n}\n\n.org-actions {\n  padding: 8px 16px 16px;\n  gap: 8px;\n  display: flex;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n@media (max-width: 640px) {\n  .org-steps-nav {\n    gap: 4px;\n  }\n\n  .org-steps-arrow {\n    width: 28px;\n    height: 28px;\n  }\n\n  .org-step-connector {\n    flex: 0 0 16px;\n    min-width: 16px;\n    margin: 0 4px;\n  }\n\n  .org-step__label {\n    font-size: 11px;\n    letter-spacing: 0.02em;\n    padding: 6px 12px;\n  }\n\n  .color-row {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .done-actions .org-btn,\n  .org-actions .org-btn {\n    flex: 1 1 auto;\n  }\n}\n\n:host-context(body.theme-dark) {\n  .org-steps-arrow {\n    background: #0f172a;\n    border-color: #334155;\n    color: #e2e8f0;\n  }\n\n  .org-step {\n    color: #64748b;\n  }\n\n  .org-step.active {\n    color: var(--org-primary, var(--fc-brand, #5ea1d8));\n\n    .org-step__label {\n      background: rgba(94, 161, 216, 0.15);\n    }\n  }\n\n  .org-step.done {\n    color: #4ade80;\n\n    .org-step__label {\n      background: rgba(74, 222, 128, 0.12);\n    }\n  }\n\n  .org-step-connector {\n    background: rgba(148, 163, 184, 0.2);\n  }\n\n  .org-step-connector--done,\n  .org-progress__fill {\n    background: #4ade80;\n  }\n\n  .org-progress__bar {\n    background: rgba(148, 163, 184, 0.2);\n  }\n\n  .org-progress__label {\n    color: #94a3b8;\n  }\n\n  .org-progress__value {\n    color: #4ade80;\n  }\n\n  .alt-admin-toggle {\n    color: #e2e8f0;\n  }\n\n  .term-section-title,\n  .term-value-group__header h4,\n  .done-panel {\n    color: #f8fafc;\n  }\n\n  .term-value-group,\n  .invited-list li {\n    background: #0f172a;\n    border-color: #334155;\n  }\n\n  .invited-list__heading,\n  .invited-list__email {\n    color: #e2e8f0;\n  }\n\n  .invited-list__note {\n    color: #94a3b8;\n  }\n\n  .logo-preview img {\n    border-color: #475569;\n    background: #0f172a;\n  }\n\n  .color-swatch {\n    border-color: #475569;\n  }\n\n  .done-icon {\n    color: #4ade80;\n  }\n}\n","/* Shared Organization UI — used by org-onboarding + org-admin + org-join */\n\n:root {\n  --org-border: #d1d5db;\n  --org-border-soft: #e6e6e6;\n  --org-surface: #ffffff;\n  --org-surface-muted: #f7f8fa;\n  --org-muted: #6b7280;\n  --org-text: #1a1a1a;\n  --org-control-height: 48px;\n  --org-control-radius: 8px;\n}\n\n.org-page {\n  max-width: 960px;\n  margin: 24px auto;\n  padding: 0 16px 40px;\n  color: var(--org-text);\n}\n\n.skeleton-org-container {\n  padding: 16px 0 8px;\n}\n\n.org-page__card {\n  border-radius: 12px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);\n  background: var(--org-surface);\n  color: inherit;\n}\n\n.org-page__card mat-card-header {\n  margin-bottom: 8px;\n}\n\n.org-page__card mat-card-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--org-text);\n}\n\n.org-page__card mat-card-subtitle {\n  color: #555;\n}\n\n.org-header-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin: 8px 0 4px;\n  align-items: center;\n}\n\n/* Bootstrap (3 via CDN + npm) gives every <label> a bottom margin and bold weight. */\n.org-field,\n.access-role-switch,\n.feature-toggle {\n  margin: 0;\n  max-width: 100%;\n  font-weight: inherit;\n}\n\n.org-field {\n  display: grid;\n  gap: 6px;\n  width: 100%;\n  min-width: 0;\n  align-content: end;\n}\n\n.org-field__label {\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.35;\n  color: #374151;\n}\n\n.org-input {\n  width: 100%;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--org-text);\n  background: var(--org-surface);\n  border: 1px solid var(--org-border);\n  border-radius: var(--org-control-radius);\n  padding: 12px 14px;\n  margin: 0;\n  min-height: var(--org-control-height);\n  line-height: 1.4;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n  box-sizing: border-box;\n\n  &::placeholder {\n    color: var(--org-muted);\n    opacity: 1;\n  }\n\n  &:focus {\n    outline: none;\n    border-color: var(--org-primary, var(--fc-brand, #5ea1d8));\n    box-shadow: 0 0 0 2px rgba(94, 161, 216, 0.15);\n  }\n\n  &:disabled {\n    opacity: 0.65;\n    cursor: not-allowed;\n    background: #f9fafb;\n  }\n}\n\ntextarea.org-input {\n  min-height: 96px;\n  resize: vertical;\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n\ninput[type=\"file\"].org-input {\n  height: var(--org-control-height);\n  min-height: var(--org-control-height);\n  padding: 8px 12px;\n  line-height: 30px;\n  cursor: pointer;\n\n  &::file-selector-button {\n    height: 30px;\n    margin: 0 10px 0 0;\n    padding: 0 12px;\n    border: 1px solid var(--org-border);\n    border-radius: 6px;\n    background: var(--org-surface-muted);\n    color: inherit;\n    font: inherit;\n    font-size: 13px;\n    cursor: pointer;\n    vertical-align: middle;\n  }\n}\n\nselect.org-input,\ninput.org-input:not([type=\"file\"]) {\n  height: var(--org-control-height);\n}\n\nselect.org-input {\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%236b7280' d='M1 1l5 5 5-5'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 14px center;\n  padding-right: 36px;\n}\n\n.org-btn {\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  margin: 0;\n  font-family: inherit;\n  white-space: nowrap;\n  box-sizing: border-box;\n  transition: all 0.2s ease;\n  text-decoration: none;\n  text-transform: none;\n  letter-spacing: 0;\n  min-height: var(--org-control-height);\n  border-radius: var(--org-control-radius);\n  font-size: 14px;\n  font-weight: 500;\n  padding: 12px 20px;\n  line-height: 1.2;\n\n  mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n  }\n}\n\n.org-btn-primary {\n  border: none;\n  background: var(--org-primary, var(--fc-brand, #5ea1d8));\n  color: #fff;\n\n  &:hover:not(:disabled) {\n    background: #4a8fc4;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n}\n\n.org-btn-ghost {\n  border: 1px solid #d1d5db;\n  background: var(--org-surface-muted);\n  color: #1f2937;\n\n  &:hover:not(:disabled) {\n    background: #e8edf5;\n    border-color: #c5cdd8;\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n  }\n}\n\n.org-btn-text {\n  border: 1px solid var(--org-primary, var(--fc-brand, #5ea1d8));\n  background: transparent;\n  color: var(--org-primary, var(--fc-brand, #5ea1d8));\n\n  &:hover:not(:disabled) {\n    background: rgba(94, 161, 216, 0.08);\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n  }\n}\n\n.org-btn-dashed {\n  width: auto;\n  border: 1px dashed var(--org-primary, var(--fc-brand, #5ea1d8));\n  background: var(--org-surface-muted);\n  color: #1f2937;\n\n  &:hover:not(:disabled) {\n    background: #e8edf5;\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n  }\n}\n\n.org-btn-dashed--block {\n  width: 100%;\n}\n\n.org-btn-remove {\n  border: none;\n  background: transparent;\n  padding: 8px 12px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #c62828;\n  min-height: auto;\n  border-radius: 6px;\n\n  &:hover:not(:disabled) {\n    background: rgba(198, 40, 40, 0.08);\n  }\n}\n\n.org-btn-warn {\n  border: none;\n  background: #c62828;\n  color: #fff;\n\n  &:hover:not(:disabled) {\n    background: #b71c1c;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n}\n\n.manage-app,\n.nested-card {\n  border: 1px solid var(--org-border-soft);\n  border-radius: 10px;\n  padding: 14px;\n  background: var(--org-surface-muted);\n  display: grid;\n  gap: 10px;\n  color: var(--org-text);\n}\n\n.manage-app__header,\n.manage-team__header,\n.nested-card__title {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.manage-app__title,\n.manage-team__title,\n.nested-card__title h3,\n.nested-card__title h4 {\n  margin: 0;\n  font-size: 1rem;\n  color: var(--org-text);\n}\n\n.manage-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n}\n\n/* Footer action bar for a form block: secondary first, primary last, right-aligned */\n.org-form-actions {\n  grid-column: 1 / -1;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n  justify-content: flex-end;\n  margin-top: 4px;\n}\n\n.org-form-actions--split {\n  justify-content: space-between;\n}\n\n.org-form-actions__group {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n}\n\n.manage-app__header > .org-btn,\n.manage-app__header .manage-actions .org-btn,\n.manage-team__header .manage-actions .org-btn,\n.nested-card__title > .org-btn {\n  height: 36px;\n  min-height: 36px;\n  padding: 0 14px;\n  font-size: 13px;\n}\n\n.org-section > .org-btn,\n.org-form-panel > .org-btn,\n.manage-app > .org-btn:not(.org-btn-dashed--block) {\n  justify-self: start;\n}\n\n.manage-team,\n.team-block {\n  margin-left: 4px;\n  padding: 10px 12px;\n  border-left: 3px solid var(--org-accent, var(--fc-brand, #5ea1d8));\n  background: #fff;\n  border-radius: 0 8px 8px 0;\n  display: grid;\n  gap: 8px;\n  color: var(--org-text);\n}\n\n.edit-grid,\n.form-grid,\n.terminology-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 10px 12px;\n  align-items: end;\n}\n\n.edit-grid--inset {\n  margin-top: 8px;\n}\n\n.edit-grid--grow {\n  flex: 1;\n  min-width: 0;\n}\n\n.invite-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 14px;\n  align-items: flex-end;\n  padding: 14px 16px;\n  border: 1px solid var(--org-border-soft);\n  border-radius: 12px;\n  background: var(--org-surface);\n  color: var(--org-text);\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.invite-row .edit-grid {\n  flex: 1;\n  min-width: 0;\n}\n\n.invite-row > .org-btn {\n  flex-shrink: 0;\n}\n\n.invite-list {\n  display: grid;\n  gap: 10px;\n}\n\n.invite-card {\n  display: grid;\n  gap: 12px;\n  padding: 16px 18px;\n  border: 1px solid var(--org-border-soft);\n  border-radius: 14px;\n  background: var(--org-surface);\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.05);\n  color: var(--org-text);\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.invite-card:hover {\n  border-color: rgba(94, 161, 216, 0.45);\n  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.06);\n}\n\n.invite-card__top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.invite-card__identity {\n  display: grid;\n  gap: 6px;\n  min-width: 0;\n}\n\n.invite-card__title {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 650;\n  color: var(--org-text);\n  word-break: break-word;\n}\n\n.invite-card__subtitle {\n  margin: 0;\n  font-size: 0.85rem;\n  color: var(--org-muted);\n  line-height: 1.4;\n}\n\n.invite-card__meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  align-items: center;\n}\n\n.invite-meta-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  background: var(--org-surface-muted);\n  border: 1px solid var(--org-border-soft);\n  color: #374151;\n  font-size: 0.75rem;\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n.invite-card__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n  justify-content: flex-end;\n  flex-shrink: 0;\n}\n\n.invite-card__body {\n  display: grid;\n  gap: 10px;\n  padding-top: 4px;\n  border-top: 1px solid var(--org-border-soft);\n}\n\n.invite-card--join .invite-card__body {\n  margin-top: 2px;\n}\n\n.invite-card__footer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  justify-content: flex-end;\n  padding-top: 4px;\n}\n\n.org-form-panel {\n  display: grid;\n  gap: 14px;\n  padding: 18px;\n  border: 1px solid var(--org-border-soft);\n  border-radius: 14px;\n  background: linear-gradient(\n    180deg,\n    var(--org-surface) 0%,\n    var(--org-surface-muted) 100%\n  );\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);\n}\n\n.org-form-panel__title {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 650;\n}\n\n.org-form-panel__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.org-form-panel__hint {\n  margin: -6px 0 0;\n  font-size: 0.85rem;\n  color: var(--org-muted);\n}\n\n.org-section-head {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px 12px;\n  margin-top: 8px;\n}\n\n.org-section-head h2 {\n  margin: 0;\n}\n\n.org-section-head__count {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--org-muted);\n}\n\n/* Status badges — Pending / Requested / Accepted / Rejected */\n.status-badge,\n.pending-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 0.7rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  line-height: 1.2;\n  white-space: nowrap;\n  border: 1px solid transparent;\n  vertical-align: middle;\n}\n\n.status-badge mat-icon,\n.pending-badge mat-icon {\n  font-size: 14px;\n  width: 14px;\n  height: 14px;\n}\n\n.status-badge--pending,\n.pending-badge {\n  background: rgba(242, 169, 0, 0.16);\n  color: #8a5a00;\n  border-color: rgba(242, 169, 0, 0.28);\n  margin-left: 0;\n}\n\n.status-badge--requested {\n  background: rgba(94, 161, 216, 0.14);\n  color: #0b3d5c;\n  border-color: rgba(94, 161, 216, 0.3);\n}\n\n.status-badge--accepted {\n  background: rgba(22, 163, 74, 0.12);\n  color: #166534;\n  border-color: rgba(22, 163, 74, 0.28);\n}\n\n.status-badge--rejected {\n  background: rgba(198, 40, 40, 0.1);\n  color: #991b1b;\n  border-color: rgba(198, 40, 40, 0.22);\n}\n\n.status-badge--incoming {\n  background: rgba(124, 58, 237, 0.1);\n  color: #5b21b6;\n  border-color: rgba(124, 58, 237, 0.22);\n}\n\n.muted,\n.hint {\n  color: #555;\n  font-size: 0.875rem;\n  margin: 0;\n}\n\n.muted-empty {\n  margin: 0;\n  color: #777;\n  font-size: 0.85rem;\n  padding: 18px 16px;\n  text-align: center;\n  border: 1px dashed var(--org-border-soft);\n  border-radius: 12px;\n  background: var(--org-surface-muted);\n}\n\n.term-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.term-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px 4px 10px;\n  border-radius: 999px;\n  background: rgba(94, 161, 216, 0.18);\n  color: #1a5278;\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n.term-chip__remove {\n  border: none;\n  background: transparent;\n  padding: 0;\n  width: 20px;\n  height: 20px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: inherit;\n  font-size: 16px;\n  line-height: 1;\n}\n\n.term-add-row,\n.org-inline-row {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 10px;\n  align-items: end;\n}\n\n.term-add-row .org-btn,\n.org-inline-row .org-btn {\n  align-self: end;\n}\n\n.library-access-panel {\n  display: grid;\n  gap: 6px;\n}\n\n.empty-state {\n  text-align: center;\n  padding: 40px 16px;\n  color: #555;\n  display: grid;\n  gap: 12px;\n  justify-items: center;\n}\n\n.empty-state mat-icon {\n  font-size: 48px;\n  width: 48px;\n  height: 48px;\n  color: var(--fc-brand, #5ea1d8);\n}\n\n.org-tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin: 16px 0 20px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--org-border-soft);\n}\n\n.org-tab {\n  border: 1px solid transparent;\n  background: transparent;\n  border-radius: 999px;\n  padding: 8px 14px;\n  font: inherit;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #555;\n  cursor: pointer;\n  min-height: 36px;\n  display: inline-flex;\n  align-items: center;\n\n  &:hover {\n    background: #f5f5f5;\n  }\n\n  &.active {\n    border-color: var(--org-primary, var(--fc-brand, #5ea1d8));\n    background: rgba(94, 161, 216, 0.12);\n    color: #0b3d5c;\n  }\n\n  .status-badge,\n  .pending-badge {\n    margin-left: 6px;\n  }\n}\n\n.org-section {\n  display: grid;\n  gap: 12px;\n}\n\n.org-section h2 {\n  margin: 0;\n  font-size: 1.1rem;\n  color: var(--org-text);\n}\n\n.editing-banner {\n  margin: 0 0 12px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  background: rgba(94, 161, 216, 0.12);\n  color: #1a5278;\n  font-size: 0.9rem;\n}\n\n/* Access roles — shared by onboarding + admin */\n.access-role-list {\n  display: grid;\n  gap: 12px;\n}\n\n.access-role-card {\n  border: 1px solid #e0e0e0;\n  border-radius: 12px;\n  background: #fff;\n  overflow: hidden;\n}\n\n.access-role-card--off {\n  opacity: 0.72;\n  background: #fafafa;\n}\n\n.access-role-card__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 12px;\n  border-bottom: 1px solid #eee;\n  background: #f8fafc;\n}\n\n.access-role-card__toggle-expand {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: 0;\n  background: transparent;\n  font: inherit;\n  font-weight: 600;\n  cursor: pointer;\n  color: var(--org-text);\n  padding: 0;\n}\n\n.access-role-card__key {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n  font-size: 0.9rem;\n}\n\n.access-role-switch {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #334155;\n  user-select: none;\n}\n\n.access-role-switch input,\n.feature-toggle input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  margin: 0;\n  flex-shrink: 0;\n}\n\n.feature-toggle input[type=\"checkbox\"] {\n  margin-top: 2px;\n}\n\n.access-role-switch.locked {\n  opacity: 0.85;\n}\n\n.access-role-card__body {\n  display: grid;\n  gap: 10px;\n  padding: 12px;\n}\n\n.access-role-features-summary {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.feature-chip {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 8px;\n  border-radius: 999px;\n  background: rgba(94, 161, 216, 0.15);\n  color: #0b3d5c;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.access-role-features__title {\n  margin: 4px 0 0;\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n\n.feature-toggle {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 8px 0;\n  border-top: 1px solid #f0f0f0;\n  cursor: pointer;\n}\n\n.feature-toggle__text {\n  display: grid;\n  gap: 2px;\n}\n\n.feature-toggle__text strong {\n  font-size: 0.9rem;\n}\n\n.feature-toggle__text small {\n  color: #64748b;\n  font-size: 0.8rem;\n}\n\n@media (max-width: 640px) {\n  .org-page {\n    margin-top: 12px;\n    padding: 0 12px 32px;\n  }\n\n  .invite-row,\n  .invite-card,\n  .manage-app__header,\n  .manage-team__header,\n  .nested-card__title {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .invite-card__top,\n  .invite-card__footer,\n  .invite-card__actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .invite-card__actions .org-btn,\n  .invite-card__footer .org-btn {\n    width: 100%;\n  }\n\n  .term-add-row,\n  .org-inline-row {\n    grid-template-columns: 1fr;\n  }\n\n  .term-add-row .org-btn,\n  .org-inline-row .org-btn {\n    width: 100%;\n  }\n\n  .manage-actions .org-btn,\n  .org-form-actions .org-btn,\n  .org-form-panel__actions .org-btn {\n    flex: 1 1 auto;\n  }\n\n  .org-form-actions,\n  .org-form-actions__group {\n    width: 100%;\n  }\n\n  .invite-row .org-btn {\n    width: 100%;\n  }\n}\n\n:host-context(body.theme-dark) {\n  .org-page {\n    color: #e5e7eb;\n  }\n\n  .org-page__card {\n    background: #1e293b;\n    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.35);\n    color: #e5e7eb;\n  }\n\n  .org-page__card mat-card-title,\n  .org-section h2,\n  .manage-app__title,\n  .manage-team__title,\n  .nested-card__title h3,\n  .nested-card__title h4 {\n    color: #f8fafc;\n  }\n\n  .org-page__card mat-card-subtitle,\n  .muted,\n  .hint,\n  .muted-empty,\n  .empty-state {\n    color: #94a3b8;\n  }\n\n  .org-field__label {\n    color: #cbd5e1;\n  }\n\n  .org-input {\n    color: #f8fafc;\n    background: #0f172a;\n    border-color: #475569;\n\n    &::placeholder {\n      color: #94a3b8;\n    }\n\n    &:focus {\n      border-color: var(--org-primary, var(--fc-brand, #5ea1d8));\n      box-shadow: 0 0 0 2px rgba(94, 161, 216, 0.25);\n    }\n\n    &:disabled {\n      background: #1e293b;\n    }\n  }\n\n  .org-btn-ghost {\n    border-color: #334155;\n    background: #0f172a;\n    color: #e5e7eb;\n\n    &:hover:not(:disabled) {\n      background: #334155;\n    }\n  }\n\n  .org-btn-text {\n    border-color: var(--org-primary, var(--fc-brand, #5ea1d8));\n    color: #7eb8e8;\n\n    &:hover:not(:disabled) {\n      background: rgba(94, 161, 216, 0.15);\n    }\n  }\n\n  .org-btn-dashed {\n    border-color: var(--org-primary, var(--fc-brand, #5ea1d8));\n    background: #0f172a;\n    color: #e5e7eb;\n\n    &:hover:not(:disabled) {\n      background: #1e293b;\n    }\n  }\n\n  .org-btn-remove {\n    color: #f87171;\n\n    &:hover:not(:disabled) {\n      background: rgba(248, 113, 113, 0.12);\n    }\n  }\n\n  .manage-app,\n  .nested-card,\n  .invite-row,\n  .invite-card,\n  .org-form-panel {\n    background: #0f172a;\n    border-color: #334155;\n    color: #e5e7eb;\n  }\n\n  .invite-card:hover {\n    border-color: rgba(94, 161, 216, 0.5);\n    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);\n  }\n\n  .invite-card__title {\n    color: #f8fafc;\n  }\n\n  .invite-card__subtitle,\n  .org-form-panel__hint,\n  .org-section-head__count {\n    color: #94a3b8;\n  }\n\n  .invite-card__body {\n    border-top-color: #334155;\n  }\n\n  .invite-meta-chip {\n    background: #1e293b;\n    border-color: #334155;\n    color: #cbd5e1;\n  }\n\n  .muted-empty {\n    background: #0f172a;\n    border-color: #334155;\n    color: #94a3b8;\n  }\n\n  .manage-team,\n  .team-block {\n    background: #1e293b;\n    color: #e5e7eb;\n  }\n\n  .org-tabs {\n    border-bottom-color: #334155;\n  }\n\n  .org-tab {\n    color: #94a3b8;\n\n    &:hover {\n      background: #0f172a;\n    }\n\n    &.active {\n      border-color: var(--org-primary, var(--fc-brand, #5ea1d8));\n      background: rgba(94, 161, 216, 0.2);\n      color: #e0f2fe;\n    }\n  }\n\n  .pending-badge,\n  .status-badge--pending {\n    background: rgba(242, 169, 0, 0.25);\n    color: #fbbf24;\n    border-color: rgba(242, 169, 0, 0.35);\n  }\n\n  .status-badge--requested {\n    background: rgba(94, 161, 216, 0.22);\n    color: #7dd3fc;\n    border-color: rgba(94, 161, 216, 0.35);\n  }\n\n  .status-badge--accepted {\n    background: rgba(34, 197, 94, 0.18);\n    color: #86efac;\n    border-color: rgba(34, 197, 94, 0.3);\n  }\n\n  .status-badge--rejected {\n    background: rgba(248, 113, 113, 0.15);\n    color: #fca5a5;\n    border-color: rgba(248, 113, 113, 0.28);\n  }\n\n  .status-badge--incoming {\n    background: rgba(167, 139, 250, 0.18);\n    color: #c4b5fd;\n    border-color: rgba(167, 139, 250, 0.3);\n  }\n\n  .term-chip {\n    background: rgba(94, 161, 216, 0.25);\n    color: #bae6fd;\n  }\n\n  .editing-banner {\n    background: rgba(94, 161, 216, 0.2);\n    color: #bae6fd;\n  }\n\n  .empty-state mat-icon {\n    color: var(--fc-brand, #5ea1d8);\n  }\n\n  .access-role-card {\n    background: #0f172a;\n    border-color: #334155;\n  }\n\n  .access-role-card--off {\n    background: #0b1220;\n  }\n\n  .access-role-card__header {\n    background: #111827;\n    border-color: #334155;\n  }\n\n  .access-role-card__toggle-expand,\n  .access-role-switch,\n  .access-role-features__title {\n    color: #e2e8f0;\n  }\n\n  .feature-chip {\n    background: rgba(94, 161, 216, 0.22);\n    color: #bae6fd;\n  }\n\n  .feature-toggle {\n    border-color: #1e293b;\n  }\n\n  .feature-toggle__text small {\n    color: #94a3b8;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
